module.exports = __webpack_public_path__ + "img/logo.70eab32d.png";